import { render } from 'react-dom'

import ContactSellerButtonMobile from './ContactSeller/ContactSellerButtonMobile'
import AddToGarageButtonMobile from '../../../components/AddToGarage/AddToGarageButtonMobile'
import CallSellerButtonMobile from './CallSellerButtonMobile'
import { ContactSellerModalProvider } from './ContactSeller/context/ContactSellerContext'

const MobileContactFooter = () => (
  <ContactSellerModalProvider>
    <div className="container-fluid fixed-contact-wrapper shadow-lg p-2 fixed-contact-show">
      <div className="row gx-2">
        <div className="col-5">
          <CallSellerButtonMobile />
        </div>
        <div className="col-5">
          <ContactSellerButtonMobile />
        </div>
        <div className="col-2">
          <AddToGarageButtonMobile />
        </div>
      </div>
    </div>
  </ContactSellerModalProvider>
)

document.addEventListener('DOMContentLoaded', () => {
  render(
    <MobileContactFooter />,
    document.getElementById('fixed-contact-content')
  )
})
